import React, { Suspense, useEffect } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { Routes, Route, useNavigate } from "react-router-dom";
import { navigationStep } from "../../redux/slices/navigation";
import { preloaderToggle } from "../../redux/slices/preloader";
import {
  BuildPrealoader,
  LinkPage,
  WifiPage,
  PdfPage,
  EmailPage,
  PlayMarketAppstore,
  WhatsAppPage,
  AudioPage,
  PptxPpt,
  TextPage,
  GallerryPage,
  PcrPage,
  CreateVCard,
  LinkListPage,
  CryptoPage,
  InstagramPage,
  FacebookPage,
  TelegramPage,
  TiktokPage,
  SnapchatPage,
  TwitterPage,
  YoutubePage,
  MultiUrlPage,
  MapPage,
  PhonePage,
  SmsPage,
  VideoPage,
  PaypalPage,
  SheetsPage,
  LogoPage,
  PaymentPage,
  DocPage,
  FormPage,
  ReviewPage,
  PngPage,
  SpotifyPage,
  OfficePage,
  EtsyPage,
  ShapedPage,
  SocialMediaPage,
  RedditPage,
  LinkedinPage,
  CalendarPage,
  FilePage,
  ExcelPage,
  FirstScreen,
  ThirdScreen,
  BookingPage,
} from "../index";
import { linkStep } from "../../redux/slices/navigation";
import SaveFile from "../saveFile/saveFile";
import useIsNoIframe from "../../hooks/useIsNoIframe";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../errorFallback";
import { useLocation } from "react-router-dom";
import axios from "axios";
import useTypeDecription from "../../hooks/useTypeDecription";
import { webView } from "../../variables/webView";
import Head from "../head";
import { fetchLanguage } from "../../redux/slices/changeLang";
import useCurrentLocation from "../../hooks/useCurrentLocation";
import { TemplatesScreen } from "../../page/TemplatesScreen";
import ConstructorPage from "../../page/ConstructorScreen";

export const Context = React.createContext();

export const SuspenseLayout = ({ children }) => {
  const isDescription = document.querySelector("#description");
  return (
    <Suspense fallback={<BuildPrealoader toggle={!isDescription} />}>
      {children}
    </Suspense>
  );
};

function Wrapper() {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { removeDescription } = useTypeDecription();
  const {
    errorFile,
    pageCounter,
    error,
    status,
    type,
    lang,
    isPreloaderToggle,
  } = useSelector(
    (state) => ({
      errorFile: state.getQrLinkSlice.errorFile,
      pageCounter: state.navigation.pageCounter,
      error: state.getQrLinkSlice.error,
      status: state.getQrLinkSlice.status,
      type: state.typeCard.type,
      lang: state.changeLang.language,
      isPreloaderToggle: state.preloader.toggle,
    }),
    shallowEqual
  );

  const { isNoIframe } = useIsNoIframe();
  const location = useLocation();
  const { entryLocation } = useCurrentLocation();

  useEffect(() => {
    const updateTypes = (type, generatorType) => {
      type.querySelector(".type-title").innerText = generatorType.title;
      type.querySelector(".type-img").setAttribute("href", generatorType.img);
      type.href = generatorType.href;
    };

    const typesByCountryUpdate = () => {
      const navElement = document.getElementById("nav");

      const updateTypes = (type, generatorType) => {
        type.querySelector(".type-title").innerText = generatorType.title;
        type.querySelector(".type-img").setAttribute("href", generatorType.img);
        type.href = generatorType.href;
      };
      if (navElement) {
        const generatorTypes = JSON.parse(
          navElement.dataset.navGeneratorTypesValue
        );
        const country = navElement.dataset.navUserCountryValue;
        const typeTargets = document.querySelectorAll(".typeByCountry");

        updateTypes(typeTargets[0], generatorTypes.link);
        updateTypes(typeTargets[1], generatorTypes.pdf);
        updateTypes(typeTargets[2], generatorTypes.image);
        updateTypes(typeTargets[3], generatorTypes.app);
        updateTypes(typeTargets[4], generatorTypes.text);
        updateTypes(typeTargets[5], generatorTypes.map);
        updateTypes(typeTargets[6], generatorTypes.wifi);
        updateTypes(typeTargets[7], generatorTypes.audio);
        updateTypes(typeTargets[8], generatorTypes.whatsapp);
        updateTypes(typeTargets[9], generatorTypes.youtube);

        if (country === "KR") {
          updateTypes(typeTargets[3], generatorTypes.app);
          updateTypes(typeTargets[4], generatorTypes.instagram);
          updateTypes(typeTargets[5], generatorTypes.audio);
          updateTypes(typeTargets[6], generatorTypes.youtube);
          updateTypes(typeTargets[7], generatorTypes.wifi);
          updateTypes(typeTargets[8], generatorTypes.text);
          updateTypes(typeTargets[9], generatorTypes.form);
        } else if (country === "CA") {
          updateTypes(typeTargets[3], generatorTypes.app);
          updateTypes(typeTargets[4], generatorTypes.youtube);
          updateTypes(typeTargets[5], generatorTypes.instagram);
          updateTypes(typeTargets[6], generatorTypes.email);
          updateTypes(typeTargets[7], generatorTypes.text);
          updateTypes(typeTargets[8], generatorTypes.audio);
          updateTypes(typeTargets[9], generatorTypes.form);
        } else if (country === "GB") {
          updateTypes(typeTargets[3], generatorTypes.whatsapp);
          updateTypes(typeTargets[4], generatorTypes.vcard);
          updateTypes(typeTargets[5], generatorTypes.text);
          updateTypes(typeTargets[6], generatorTypes.app);
          updateTypes(typeTargets[7], generatorTypes.youtube);
          updateTypes(typeTargets[8], generatorTypes.email);
          updateTypes(typeTargets[9], generatorTypes.instagram);
        } else if (country === "IT") {
          updateTypes(typeTargets[3], generatorTypes.audio);
          updateTypes(typeTargets[4], generatorTypes.instagram);
          updateTypes(typeTargets[5], generatorTypes.whatsapp);
          updateTypes(typeTargets[6], generatorTypes.wifi);
          updateTypes(typeTargets[7], generatorTypes.text);
          updateTypes(typeTargets[8], generatorTypes.map);
          updateTypes(typeTargets[9], generatorTypes.youtube);
        } else if (country === "BR") {
          updateTypes(typeTargets[2], generatorTypes.whatsapp);
          updateTypes(typeTargets[3], generatorTypes.image);
          updateTypes(typeTargets[4], generatorTypes.app);
          updateTypes(typeTargets[5], generatorTypes.instagram);
          updateTypes(typeTargets[6], generatorTypes.youtube);
          updateTypes(typeTargets[7], generatorTypes.text);
          updateTypes(typeTargets[8], generatorTypes.wifi);
          updateTypes(typeTargets[9], generatorTypes.audio);
        } else if (country === "DE") {
          updateTypes(typeTargets[3], generatorTypes.audio);
          updateTypes(typeTargets[4], generatorTypes.text);
          updateTypes(typeTargets[5], generatorTypes.app);
          updateTypes(typeTargets[6], generatorTypes.instagram);
          updateTypes(typeTargets[7], generatorTypes.map);
          updateTypes(typeTargets[8], generatorTypes.youtube);
          updateTypes(typeTargets[9], generatorTypes.wifi);
        } else if (country === "KW") {
          updateTypes(typeTargets[3], generatorTypes.whatsapp);
          updateTypes(typeTargets[4], generatorTypes.map);
          updateTypes(typeTargets[5], generatorTypes.instagram);
          updateTypes(typeTargets[6], generatorTypes.youtube);
          updateTypes(typeTargets[7], generatorTypes.app);
          updateTypes(typeTargets[8], generatorTypes.email);
          updateTypes(typeTargets[9], generatorTypes.vcard);
        } else if (country === "MX") {
          updateTypes(typeTargets[3], generatorTypes.whatsapp);
          updateTypes(typeTargets[4], generatorTypes.map);
          updateTypes(typeTargets[5], generatorTypes.youtube);
          updateTypes(typeTargets[6], generatorTypes.form);
          updateTypes(typeTargets[7], generatorTypes.facebook);
          updateTypes(typeTargets[8], generatorTypes.wifi);
          updateTypes(typeTargets[9], generatorTypes.instagram);
        } else if (country === "OM") {
          updateTypes(typeTargets[3], generatorTypes.audio);
          updateTypes(typeTargets[4], generatorTypes.map);
          updateTypes(typeTargets[5], generatorTypes.instagram);
          updateTypes(typeTargets[6], generatorTypes.youtube);
          updateTypes(typeTargets[7], generatorTypes.whatsapp);
          updateTypes(typeTargets[8], generatorTypes.text);
          updateTypes(typeTargets[9], generatorTypes.wifi);
        } else if (country === "ES") {
          updateTypes(typeTargets[3], generatorTypes.audio);
          updateTypes(typeTargets[4], generatorTypes.youtube);
          updateTypes(typeTargets[5], generatorTypes.whatsapp);
          updateTypes(typeTargets[6], generatorTypes.text);
          updateTypes(typeTargets[7], generatorTypes.map);
          updateTypes(typeTargets[8], generatorTypes.instagram);
          updateTypes(typeTargets[9], generatorTypes.wifi);
        } else if (country === "FR") {
          updateTypes(typeTargets[3], generatorTypes.audio);
          updateTypes(typeTargets[4], generatorTypes.youtube);
          updateTypes(typeTargets[5], generatorTypes.app);
          updateTypes(typeTargets[6], generatorTypes.instagram);
          updateTypes(typeTargets[7], generatorTypes.vcard);
          updateTypes(typeTargets[8], generatorTypes.text);
          updateTypes(typeTargets[9], generatorTypes.map);
        } else if (country === "TH") {
          updateTypes(typeTargets[3], generatorTypes.map);
          updateTypes(typeTargets[4], generatorTypes.facebook);
          updateTypes(typeTargets[5], generatorTypes.youtube);
          updateTypes(typeTargets[6], generatorTypes.form);
          updateTypes(typeTargets[7], generatorTypes.text);
          updateTypes(typeTargets[8], generatorTypes.app);
          updateTypes(typeTargets[9], generatorTypes.excel);
        } else if (country === "JA") {
          updateTypes(typeTargets[3], generatorTypes.youtube);
          updateTypes(typeTargets[4], generatorTypes.email);
          updateTypes(typeTargets[5], generatorTypes.audio);
          updateTypes(typeTargets[6], generatorTypes.app);
          updateTypes(typeTargets[7], generatorTypes.text);
          updateTypes(typeTargets[8], generatorTypes.wifi);
          updateTypes(typeTargets[9], generatorTypes.twitter);
        } else if (country === "AE") {
          updateTypes(typeTargets[2], generatorTypes.whatsapp);
          updateTypes(typeTargets[3], generatorTypes.image);
          updateTypes(typeTargets[4], generatorTypes.map);
          updateTypes(typeTargets[5], generatorTypes.vcard);
          updateTypes(typeTargets[6], generatorTypes.instagram);
          updateTypes(typeTargets[7], generatorTypes.email);
          updateTypes(typeTargets[8], generatorTypes.text);
          updateTypes(typeTargets[9], generatorTypes.app);
        } else if (country === "SA") {
          updateTypes(typeTargets[3], generatorTypes.whatsapp);
          updateTypes(typeTargets[4], generatorTypes.map);
          updateTypes(typeTargets[5], generatorTypes.multiurl);
          updateTypes(typeTargets[6], generatorTypes.email);
          updateTypes(typeTargets[7], generatorTypes.text);
          updateTypes(typeTargets[8], generatorTypes.instagram);
          updateTypes(typeTargets[9], generatorTypes.vcard);
        } else if (country === "US") {
          updateTypes(typeTargets[3], generatorTypes.whatsapp);
          updateTypes(typeTargets[4], generatorTypes.youtube);
          updateTypes(typeTargets[5], generatorTypes.text);
          updateTypes(typeTargets[6], generatorTypes.instagram);
          updateTypes(typeTargets[7], generatorTypes.map);
          updateTypes(typeTargets[8], generatorTypes.vcard);
          updateTypes(typeTargets[9], generatorTypes.app);
        } else if (country === "CH") {
          updateTypes(typeTargets[2], generatorTypes.audio);
          updateTypes(typeTargets[3], generatorTypes.image);
          updateTypes(typeTargets[4], generatorTypes.youtube);
          updateTypes(typeTargets[5], generatorTypes.email);
          updateTypes(typeTargets[6], generatorTypes.instagram);
          updateTypes(typeTargets[7], generatorTypes.text);
          updateTypes(typeTargets[8], generatorTypes.app);
          updateTypes(typeTargets[9], generatorTypes.vcard);
        }
      }
    };

    const setCookie = (cName, cValue, expDays) => {
      let date = new Date();
      date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
      const expires = "expires=" + date.toUTCString();
      document.cookie = `${cName}=${cValue}; ${expires}; path=/`;
    };

    const initWebView = () => {
      document.cookie = "allowCookies=1";
      document.querySelector(".modal-cookies")?.classList.add("d-none");
      localStorage.setItem("isClosedApps", JSON.stringify(true));
      document.querySelector(".modal-apps")?.classList.add("d-none");
      document.querySelector("#span-menu")?.parentNode.classList.add("d-none");
      document.querySelector("#head-avatar")?.classList.add("d-none");

      const logoImg = document.querySelector("#logo-image");
      logoImg?.classList.add("m-auto");
      logoImg?.removeAttribute("href");
    };

    const initLanguageSwitching = () => {
      document.querySelectorAll(".lang").forEach((el) => {
        el.addEventListener("click", (e) => {
          e.preventDefault();
          setCookie("user_local", e.currentTarget.hreflang, 360);
          window.location.href = e.currentTarget.href;
        });
      });
    };

    const fetchQrCounts = () => {
      if (document.querySelector("#app-user")) {
        const qrCounts = document.querySelectorAll(".qr-count");
        qrCounts.forEach((target) => (target.style.opacity = "0"));

        axios.get("/qr-count").then(({ data }) => {
          qrCounts.forEach((target) => {
            target.style.opacity = "1";
            target.innerHTML = data;
          });
        });
      }
    };

    // Вызов функций
    typesByCountryUpdate();

    if (webView) {
      initWebView();
    }

    initLanguageSwitching();
    fetchQrCounts();
  }, []);

  useEffect(() => {
    if (
      pageCounter === 1 ||
      pageCounter === 3 ||
      (pageCounter === 2 && webView)
    ) {
      removeDescription();
    }
  }, [pageCounter]);

  useEffect(() => {
    if (entryLocation) {
      return;
    }
    const generatorStr = "/qr-code-generator";
    const url = generatorStr + location.pathname + location.search;
    const languages = document.querySelectorAll(".dropdown-item.lang");
    languages?.forEach((item) => {
      const attr = item.getAttribute("href");
      item.setAttribute(
        "href",
        attr.slice(0, generatorStr.length) === generatorStr
          ? url
          : attr.slice(0, 3) + url
      );
    });
  }, [location.pathname]);

  useEffect(() => {
    if (!isNoIframe) {
      document.body.style.backgroundColor = "#4f4444";
      document.querySelector("#head-menu")?.remove();
    }

    dispatch(fetchLanguage());

    let cokkiLocale = document.cookie.replace(
      /(?:(?:^|.*;\s*)user_local\s*\=\s*([^;]*).*$)|^.*$/,
      "$1"
    );

    if (entryLocation) {
      dispatch(navigationStep(3));
    }
  }, []);

  useEffect(() => {
    if (pageCounter === 3 && entryLocation) {
      dispatch(preloaderToggle(true));
    }
  }, [pageCounter]);

  useEffect(() => {
    if (pageCounter > 2 && status === "failed") {
      dispatch(navigationStep(2));
      navigate(`/${type}`);
      if (!isNoIframe) {
        history.replaceState({}, null, `${window.location.href}/iframe`);
      }
      setTimeout(() => {
        dispatch(preloaderToggle(false));
      }, 500);
    }
  }, [error, status, pageCounter]);
  useEffect(() => {
    if (!!errorFile) {
      dispatch(navigationStep(2));
      dispatch(linkStep(false));
      navigate(`/${type}`);
      setTimeout(() => {
        dispatch(preloaderToggle(false));
        dispatch(linkStep(false));
      }, 500);
    }
  }, [errorFile]);

  const renderPaths = (paths, element) =>
    paths.map((path) => (
      <Route
        key={path}
        path={path}
        element={<SuspenseLayout>{element}</SuspenseLayout>}
      />
    ));

  if (!lang) {
    return null;
  } else if (entryLocation) {
    return (
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onReset={() => {
          window.location.reload();
        }}
      >
        <>
          {pageCounter === 3 && (
            <>
              <BuildPrealoader />
              <SuspenseLayout>
                <ThirdScreen />
              </SuspenseLayout>
            </>
          )}
        </>
      </ErrorBoundary>
    );
  } else {
    return (
      <>
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onReset={() => {
            window.location.reload();
          }}
        >
          {isPreloaderToggle && <BuildPrealoader />}
          <Head />
          <SaveFile>
            <Routes>
              <Route
                index
                exact
                path="/"
                element={
                  <SuspenseLayout>
                    <FirstScreen />
                  </SuspenseLayout>
                }
              />
              <Route
                exact
                path="/qr"
                element={
                  <SuspenseLayout>
                    <ThirdScreen />
                  </SuspenseLayout>
                }
              />
              <Route
                exact
                path="/crypto"
                element={
                  <SuspenseLayout>
                    <CryptoPage />
                  </SuspenseLayout>
                }
              />
              {renderPaths(
                ["/link", "/link/:id/edit", "/link/iframe"],
                <LinkPage />
              )}
              {renderPaths(["/wi-fi", "/wi-fi/:id/edit"], <WifiPage />)}
              {renderPaths(
                ["/pdf", "/pdf/:id/edit", "/pdf/iframe"],
                <PdfPage />
              )}
              {renderPaths(["/vcard", "/vcard/:id/edit"], <CreateVCard />)}
              {renderPaths(["/email", "/email/:id/edit"], <EmailPage />)}
              {renderPaths(
                ["/store", "/store/:id/edit"],
                <PlayMarketAppstore />
              )}
              {renderPaths(
                ["/whatsapp", "/whatsapp/:id/edit"],
                <WhatsAppPage />
              )}
              {renderPaths(["/audio", "/audio/:id/edit"], <AudioPage />)}
              {renderPaths(["/pptx", "/pptx/:id/edit"], <PptxPpt />)}
              {renderPaths(["/text", "/text/:id/edit"], <TextPage />)}
              {renderPaths(["/image", "/image/:id/edit"], <GallerryPage />)}
              {renderPaths(["/pcr", "/pcr/:id/edit"], <PcrPage />)}
              {renderPaths(
                ["/link-list", "/link-list/:id/edit"],
                <LinkListPage />
              )}
              {renderPaths(
                ["/instagram", "/instagram/:id/edit"],
                <InstagramPage />
              )}
              {renderPaths(
                ["/facebook", "/facebook/:id/edit"],
                <FacebookPage />
              )}
              {renderPaths(
                ["/telegram", "/telegram/:id/edit"],
                <TelegramPage />
              )}
              {renderPaths(["/tiktok", "/tiktok/:id/edit"], <TiktokPage />)}
              {renderPaths(
                ["/snapchat", "/snapchat/:id/edit"],
                <SnapchatPage />
              )}
              {renderPaths(["/twitter", "/twitter/:id/edit"], <TwitterPage />)}
              {renderPaths(["/youtube", "/youtube/:id/edit"], <YoutubePage />)}
              {renderPaths(
                ["/multiurl", "/multiurl/:id/edit"],
                <MultiUrlPage />
              )}
              {renderPaths(["/map", "/map/:id/edit"], <MapPage />)}
              {renderPaths(["/phone", "/phone/:id/edit"], <PhonePage />)}
              {renderPaths(["/sms", "/sms/:id/edit"], <SmsPage />)}
              {renderPaths(["/video", "/video/:id/edit"], <VideoPage />)}
              {renderPaths(["/paypal", "/paypal/:id/edit"], <PaypalPage />)}
              {renderPaths(
                ["/google-sheet", "/google-sheet/:id/edit"],
                <SheetsPage />
              )}
              {renderPaths(["/with-logo", "/with-logo/:id/edit"], <LogoPage />)}
              {renderPaths(
                ["/for-payment", "/for-payment/:id/edit"],
                <PaymentPage />
              )}
              {renderPaths(
                ["/google-doc", "/google-doc/:id/edit", "/google-doc/iframe"],
                <DocPage />
              )}
              {renderPaths(
                [
                  "/google-form",
                  "/google-form/:id/edit",
                  "/google-form/iframe",
                ],
                <FormPage />
              )}
              {renderPaths(
                ["/google-review", "/google-review/:id/edit"],
                <ReviewPage />
              )}
              {renderPaths(["/png", "/png/:id/edit"], <PngPage />)}
              {renderPaths(["/spotify", "/spotify/:id/edit"], <SpotifyPage />)}
              {renderPaths(
                ["/office-365", "/office-365/:id/edit"],
                <OfficePage />
              )}
              {renderPaths(["/etsy", "/etsy/:id/edit"], <EtsyPage />)}
              {renderPaths(
                ["/shape-generator", "/shape-generator/:id/edit"],
                <ShapedPage />
              )}
              {renderPaths(
                ["/social-media", "/social-media/:id/edit"],
                <SocialMediaPage />
              )}
              {renderPaths(["/reddit", "/reddit/:id/edit"], <RedditPage />)}
              {renderPaths(
                ["/linkedin", "/linkedin/:id/edit"],
                <LinkedinPage />
              )}
              {renderPaths(
                ["/calendar", "/calendar/:id/edit"],
                <CalendarPage />
              )}
              {renderPaths(["/file", "/file/:id/edit"], <FilePage />)}
              {renderPaths(["/excel", "/excel/:id/edit"], <ExcelPage />)}
              {renderPaths(["/booking", "/booking/:id/edit"], <BookingPage />)}
              <Route
                index
                exact
                path="/templates"
                element={
                  <SuspenseLayout>
                    <TemplatesScreen />
                  </SuspenseLayout>
                }
              />
              <Route
                path="/constructor/:id/edit/template"
                element={
                  <Suspense fallback={<div>Loading...</div>}>
                    <SuspenseLayout>
                      <TemplatesScreen />
                    </SuspenseLayout>
                  </Suspense>
                }
              />
              {renderPaths(["/constructor/:id/edit"], <ConstructorPage />)}
            </Routes>
          </SaveFile>
        </ErrorBoundary>
      </>
    );
  }
}

export default Wrapper;
